import { mclAuth } from "../api/Mcl";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";

const useMclAuth = () => {
    const refresh = useRefreshToken();
    const { auth } = useAuth();

    useEffect(() => {

        const requestIntercept = mclAuth.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${auth?.accessToken}`;
                }
                // console.log('token', auth?.accessToken)
                return config;
            }, (error) => Promise.reject(error)
        );

        const responseIntercept = mclAuth.interceptors.response.use(
            response => response,
            async (error) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 403 && !prevRequest?.sent) {
                    // console.log('refresh request')
                    prevRequest.sent = true;
                    const newAccessToken = await refresh();
                    prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    return mclAuth(prevRequest);
                }
                return Promise.reject(error);
            }
        );

        return () => {
            mclAuth.interceptors.request.eject(requestIntercept);
            mclAuth.interceptors.response.eject(responseIntercept);
        }
    }, [auth, refresh])

    return mclAuth;
}

export default useMclAuth;